/**
 * Sidebar collapse init/persist (US-AE-IMP2.T02 · @UC9136).
 *
 * Bug rev2 #29b: sidebar KHÔNG thu gọn được và không nhớ trạng thái qua reload.
 * Mirror pattern theme.ts: resolveInitial* đọc localStorage lúc boot, persist* round-trip.
 * localStorage có thể chặn (private mode) → fail-safe về expand, không crash UX.
 */
export const SIDEBAR_STORAGE_KEY = "gp_admin_sidebar";

const COLLAPSED = "collapsed";
const EXPANDED = "expanded";

/** Đọc trạng thái collapse đã lưu; chưa lưu / giá trị lạ → expand (false). */
export function resolveInitialCollapsed(): boolean {
  if (typeof localStorage === "undefined") return false;
  try {
    return localStorage.getItem(SIDEBAR_STORAGE_KEY) === COLLAPSED;
  } catch {
    // localStorage bị chặn — rơi về expand.
    return false;
  }
}

/** Lưu trạng thái collapse (dùng bởi toggle). Không lưu được vẫn không chặn UX. */
export function persistSidebarCollapsed(collapsed: boolean): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(SIDEBAR_STORAGE_KEY, collapsed ? COLLAPSED : EXPANDED);
  } catch {
    // Bỏ qua: trạng thái vẫn sống trong phiên hiện tại.
  }
}
